import { Col, Row } from "reactstrap";

interface Props {
    children: React.ReactNode
}

export const ContentBody = (props: Props) => {
    return (
        <Row>
            <Col className="contentBody">
                {props.children}
            </Col>
        </Row>
    );
};
